var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy-icon_svg__copy-icon_svg__Canvas",
    transform: "translate(8095 2122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copy-icon_svg__copy-icon_svg__noun_389525_cc"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copy-icon_svg__copy-icon_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copy-icon_svg__copy-icon_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#copy-icon_svg__copy-icon_svg__path0_fill",
    transform: "translate(-8094.72 -2121.2)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "copy-icon_svg__copy-icon_svg__path0_fill",
    fillRule: "evenodd",
    d: "M 13.5586 5.08442L 13.5586 0L 0 0L 0 15.2478L 4.51631 15.2478L 4.51631 20.3323L 18.0749 20.3323L 18.0749 5.08442L 13.5586 5.08442ZM 1.80811 13.2154L 1.80811 2.03296L 11.7517 2.03296L 11.7517 13.2154L 1.80811 13.2154ZM 16.2679 18.2943L 6.3291 18.2943L 6.3291 15.2426L 13.5591 15.2426L 13.5591 7.11182L 16.2679 7.11182L 16.2679 18.2943Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.68563a936870b551c8002fa248b62455.svg";
export { ForwardRef as ReactComponent };